import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=a1141f98&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=a1141f98&prod&lang=scss"
import style1 from "./Language.vue?vue&type=style&index=1&id=a1141f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1141f98",
  null
  
)

export default component.exports